import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';


import { Ano} from './../distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';


import { IndiceParticipacaoMunicipioService } from './shared/service/indiceParticipacaoMunicipio';
import { Municipio, IndiceParticipacaoMunicipioFiltro, IndiceParticipacaoMunicipioModelView  } from './shared/model/IndiceParticipacaoMunicipio.model';

@Component({
  selector: 'sarf-indice-participacao-municipio',
  templateUrl: './indice-participacao-municipio.component.html'
})

export class IndiceParticipacaoMunicipioComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  showFile: ShowFile;
  aslibModal: AslibModalComponent;
  exibirGrid: boolean;
  anoSelected: Ano;
  municipioSelected: Municipio;
  listaAno: Ano[];
  listaMunicipio: Municipio[];
  tipoRel: number;
  filtro: IndiceParticipacaoMunicipioFiltro;
  indiceParticipacaoMunicipioModelView: IndiceParticipacaoMunicipioModelView;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;

  constructor(
    private readonly indiceParticipacaoMunicipioService: IndiceParticipacaoMunicipioService,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.indiceParticipacaoMunicipioModelView = new IndiceParticipacaoMunicipioModelView();
    this.filtro =   new IndiceParticipacaoMunicipioFiltro();
    this.exibirGrid =false;
  }

  formIndiceMensal = new FormGroup({
    Ano: new FormControl(undefined, Validators.required),
    Municipio: new FormControl()
  });

  ngOnInit() {
    this.dadosOnInitFormulario(this.modalMensagem);
    this.exibirGrid = false;
  }

  dadosOnInitFormulario(modal: AslibModalComponent){

    this.observerOnIniftFormulario = this.indiceParticipacaoMunicipioService.dadosOnInitFormulario().subscribe(
      retornoRequest => {
        this.exibirGrid = false;
        this.listaAno = retornoRequest.ListaAno;
        this.listaMunicipio = retornoRequest.ListaMunicipio;
        this.setarMaiorAnoDaLista();
        this.tipoRel  = ExportTypes.PDF;
        this.filtroConsulta();
      

        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }

  public setarMaiorAnoDaLista(){

    if(this.listaAno != null && this.listaAno.length > 0){
      this.anoSelected = this.listaAno[0];
    }
  }

  public onChangeAno(){
    this.indiceParticipacaoMunicipioModelView = new IndiceParticipacaoMunicipioModelView();
  }

  public consultarIndiceParticipacaoMunicipio(modal: AslibModalComponent){

    this.filtroConsulta();
      this.observerOnIniftFormulario = this.indiceParticipacaoMunicipioService
      .consultarIndiceParticipacaoMunicipio(this.filtro).subscribe(
        retornoRequest => {
         
          this.indiceParticipacaoMunicipioModelView.ListaIndiceMensalMunicpio = retornoRequest.ListaIndiceMensalMunicpio;
          
          let c = this.indiceParticipacaoMunicipioModelView.ListaIndiceMensalMunicpio.length;
          
          this.exibirGrid = c > 0?true:false;

          if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
          }
        },
        () => this.observerOnIniftFormulario.unsubscribe()
      );
    

  }

  public filtroConsulta(){
 
    this.filtro.IdAno= this.anoSelected? this.anoSelected.IdAno : null;
    this.filtro.IdMunicipio =  this.municipioSelected ? this.municipioSelected.IdMunicipio : null;
    this.filtro.DescricaoMunicipio = this.municipioSelected ? this.municipioSelected.Descricao : null;
  }

  gerarRelatorio(tipoFile: number) {
  
    let tipoRel: ExportTypes;
    
    tipoRel = tipoFile==0?ExportTypes.PDF:ExportTypes.Excel_xls;
    this.filtroConsulta();
    this._aslibLoadingService.start();
    this.subscription = this.indiceParticipacaoMunicipioService
      .gerarRelatorioIndiceParticipacao(this.filtro,
      tipoRel  )
      .subscribe(
        data => {
          this.showFile.Windows(data,tipoRel);
        },
        (error: any) => {
          this._aslibLoadingService.complete();
          new AslibModalComponent(this._aslibModalService).open({
            title: 'ERRO',
            text: this._messages.MN0011,
            type: 'erro'
          });
        },
        () => {
         this.unSubscribe();
        }
      );
    }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/indice-participacao-municipio/indice-participacao-municipio.component.ts